export function initMarginalia() {
    const content = document.querySelector('.gh-content');
    if (!content) return;

    const notes = Array.from(content.querySelectorAll('.marginnote'));
    if (!notes.length) return;

    const container = document.querySelector('.gh-marginalia-notes');
    if (!container) return;

    const section = document.querySelector('.gh-marginalia-section');
    if (section) section.classList.add('is-active');

    const body = document.querySelector('.gh-article-body');
    if (!body) return;

    // Remove the placeholder paragraph if present
    const placeholder = container.previousElementSibling;
    if (placeholder && placeholder.tagName === 'P') {
        placeholder.remove();
    }

    const bodyTop = body.getBoundingClientRect().top + window.scrollY;
    const noteEls = [];

    notes.forEach((note) => {
        const top = note.getBoundingClientRect().top + window.scrollY - bodyTop;

        const el = document.createElement('div');
        el.className = 'gh-marginalia-note';
        el.innerHTML = note.innerHTML;
        el.style.top = `${top}px`;

        container.appendChild(el);
        noteEls.push(el);

        note.remove();
    });

    preventOverlap(noteEls);

    let resizeTimer;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => reposition(noteEls, container, body), 200);
    });
}

function preventOverlap(els) {
    for (let i = 1; i < els.length; i++) {
        const prev = els[i - 1];
        const prevBottom = prev.offsetTop + prev.offsetHeight + 16;
        if (els[i].offsetTop < prevBottom) {
            els[i].style.top = `${prevBottom}px`;
        }
    }
}

function reposition(els, container, body) {
    // On mobile the marginalia column is hidden — nothing to reposition
    if (container.offsetParent === null) return;

    const bodyTop = body.getBoundingClientRect().top + window.scrollY;
    const contentNotes = Array.from(document.querySelectorAll('.gh-content .marginnote'));

    // If notes are still in the DOM (shouldn't be, but guard), skip
    if (contentNotes.length) return;

    // Recalculate is not possible once notes are moved — overlap prevention only
    preventOverlap(els);
}
